import type React from 'react';

function ZendeskIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 874.35 874.35"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Zendesk Icon</title>

      <g id="Lager_1-2" data-name="Lager 1">
        <path d="M405.5,273.74v481.68H6.56L405.5,273.74Zm0-172.84c0,110.13-89.34,199.47-199.47,199.47S6.56,211.03,6.56,100.9H405.5Zm65.79,654.52c0-110.24,89.23-199.47,199.47-199.47s199.47,89.34,199.47,199.47H471.29Zm0-172.95V100.9h398.94l-398.94,481.57Z" />
        <rect width="874.35" height="874.35" fill="none" />
      </g>
    </svg>
  );
}

export default ZendeskIcon;
